/* eslint-disable react/prop-types */
import React, { useState, useContext } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

import { formatCurrency } from '../../service/utils';
import api from '../../service/axios/api';
import FlashContext from '../../components/contexts/FlashContext';
import Loading from '../../components/loading/Loading';

const useStyles = makeStyles({
  root: { width: '100%' },
  emptyState: {
    textAlign: 'center',
    padding: 40,
    color: '#aaa',
  },
});

const StyledTableCell = withStyles(() => ({
  head: { backgroundColor: '#303474', color: 'white' },
  body: { fontSize: 14 },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const providerColor = {
  Niky: { backgroundColor: '#e3f2fd', color: '#0d47a1' },
  BePay: { backgroundColor: '#fce4ec', color: '#880e4f' },
};

export default function ReconciliationErrorsTable({
  docs,
  page,
  setPage,
  itens,
  setItens,
  total,
  searchData,
}) {
  const classes = useStyles();
  const { notifyError, notifySuccess } = useContext(FlashContext);

  const [confirmItem, setConfirmItem] = useState(null);
  const [loadingRelease, setLoadingRelease] = useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setItens(Number(event.target.value));
    setPage(0);
  };

  const handleConfirmRelease = async () => {
    if (!confirmItem) return;
    setLoadingRelease(true);
    try {
      const { data } = await api.cards.releaseReconciliationItem(
        confirmItem.order_item_id
      );
      notifySuccess(data.message);
      setConfirmItem(null);
      searchData();
    } catch (error) {
      if (error.problems?.length > 0) {
        error.problems.forEach((err) => notifyError(err.msg));
      } else {
        notifyError(error.message);
      }
    } finally {
      setLoadingRelease(false);
    }
  };

  return (
    <>
      <Loading open={loadingRelease} msg="Liberando item..." />

      <Paper className={classes.root}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>Provedor</StyledTableCell>
                <StyledTableCell>Pedido</StyledTableCell>
                <StyledTableCell>Proxy/Identificador</StyledTableCell>
                <StyledTableCell>Valor</StyledTableCell>
                <StyledTableCell>Código de Retorno</StyledTableCell>
                <StyledTableCell>Mensagem</StyledTableCell>
                <StyledTableCell>Data</StyledTableCell>
                <StyledTableCell align="right">Ação</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {docs.map((doc) => (
                <StyledTableRow key={`${doc.provider}-${doc.order_item_id}`}>
                  <StyledTableCell>
                    <Chip
                      label={doc.provider}
                      size="small"
                      style={providerColor[doc.provider] || {}}
                    />
                  </StyledTableCell>
                  <StyledTableCell>{doc.order_number || '-'}</StyledTableCell>
                  <StyledTableCell>{doc.identifier || '-'}</StyledTableCell>
                  <StyledTableCell>
                    {formatCurrency(doc.amount || 0)}
                  </StyledTableCell>
                  <StyledTableCell>{doc.return_code || '-'}</StyledTableCell>
                  <StyledTableCell>{doc.return_message || '-'}</StyledTableCell>
                  <StyledTableCell>
                    {doc.date && moment(doc.date).format('DD/MM/YYYY HH:mm')}
                  </StyledTableCell>
                  <StyledTableCell align="right">
                    <Button
                      size="small"
                      variant="outlined"
                      color="primary"
                      onClick={() => setConfirmItem(doc)}
                    >
                      Liberar novamente
                    </Button>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>

          {docs.length === 0 && (
            <div className={classes.emptyState}>
              Nenhum item rejeitado por erro de conciliação encontrado.
            </div>
          )}
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100]}
          component="div"
          count={total}
          rowsPerPage={itens}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>

      <Dialog open={Boolean(confirmItem)} onClose={() => setConfirmItem(null)}>
        <DialogTitle>Liberar item para reprocessamento?</DialogTitle>
        <DialogContent>
          {confirmItem && (
            <>
              <p>
                <strong>Provedor:</strong> {confirmItem.provider}
              </p>
              <p>
                <strong>Pedido:</strong> {confirmItem.order_number || '-'}
              </p>
              <p>
                <strong>Erro original:</strong> {confirmItem.return_message}
              </p>
              <p>
                O status do item volta para <strong>Aguardando Processamento</strong>,
                e ele passa a ser incluído normalmente na próxima liberação de carga.
              </p>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmItem(null)} color="secondary">
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmRelease}
            color="primary"
            variant="contained"
            disabled={loadingRelease}
          >
            Confirmar liberação
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
